export default __webpack_public_path__ + "static/media/button-fireworks-svgrepo-com.6889acb5.svg";